import { render, staticRenderFns } from "./CaseRoot.vue?vue&type=template&id=c9a62d6e&scoped=true"
import script from "./CaseRoot.vue?vue&type=script&lang=js"
export * from "./CaseRoot.vue?vue&type=script&lang=js"
import style0 from "./CaseRoot.vue?vue&type=style&index=0&id=c9a62d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a62d6e",
  null
  
)

export default component.exports